import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddVideo = () => {
  const [videoUrl, setVideoUrl] = useState('');
  const [status, setStatus] = useState('active');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await postRequest('live-videos', {
        youtube_url: videoUrl,
        status
      });
      toast.success('Video added successfully!', {
        position: 'top-right',
        autoClose: 2000
      });
      setTimeout(() => {
        navigate('/video');
      }, 2000);
    } catch (error) {
      console.error('Failed to add video:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Video</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="admin-label" htmlFor="video-url">YouTube URL</label>
            <input
              id="video-url"
              type="url"
              className="form-control"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              placeholder="https://www.youtube.com/watch?v=..."
              required
            />
          </div>
          <div className="form-group">
            <label className="admin-label" htmlFor="video-status">Status</label>
            <select
              id="video-status"
              className="form-control"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <button type="submit" className="btn addbtn">
            Save
          </button>
        </form>
        {videoUrl ? (
          <p className="mt-3">URL: {videoUrl}</p>
        ) : null}
      </div>
    </div>
  );
};

export default AddVideo;
